// @flow
import React from 'react';
import {
  Input, Button, Card, H2,
} from 'components';
import routes from 'constants/routes';
import { useFormik } from 'formik';
import locale from 'assets/locale';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import actionTypes from '../../store/auth/actionTypes';
import P from '../../components/Typography/P';
import CustomLink from '../../components/CustomLink/Link';

type Props = {
  history: any,
};

const LogIn = ({ history }: Props) => {
  const dispatch = useDispatch();
  const signIn = (e) => dispatch({ type: actionTypes.SIGN_IN, payload: e });
  const { loading: isLoginInProgress } = useSelector((state) => state.api.SIGN_IN);
  const initialFormState = {
    email: '',
    password: '',
  };
  const formik = useFormik({
    initialValues: initialFormState,
    onSubmit: (values) => {
      const { state } = history.location;
      const data = {
        ...values,
        pathName: state ? state.from.pathname : routes.app.combinationTable.root,
      };
      signIn(data);
    },

    validate: (values) => {
      const errors = {};

      if (!values.email) {
        errors.email = locale.errors.account.email;
      }

      if (!values.password) {
        errors.password = locale.errors.common.required;
      }

      return errors;
    },
  });
  const {
    values,
    errors,
    isValid,
    touched,
    handleBlur,
  } = formik;
  const isButtonDisabled = !isValid;
  return (
    <form onSubmit={formik.handleSubmit}>
      <Card
        className={styles.containerForm}
        use="light"
        title={<H2 color="dark" className={styles.title}>Log In</H2>}
      >
        <P use="dark">Email</P>
        <Input
          value={values.email}
          onChange={formik.handleChange}
          name="email"
          error={touched.email && errors.email}
          onBlur={handleBlur}
        />
        <P use="dark">Password</P>
        <Input
          value={values.password}
          name="password"
          type="password"
          onChange={formik.handleChange}
          error={touched.password && errors.password}
          onBlur={handleBlur}
        />
        <div className={styles.forgot}>
          <CustomLink
            use="black"
            name="Forgot password?"
            to={routes.auth.reset.root}
          />
        </div>
        <Button
          disabled={isButtonDisabled}
          name="LOG IN"
          type="submit"
          use="superBlue"
          fill
          loading={isLoginInProgress}
        />
        <div className={styles.buttonWrapper}>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <P use="dark">Don't have an account yet?</P>
          <CustomLink use="black" name="Sign Up" to={routes.auth.signUp.root} />
        </div>
      </Card>
    </form>
  );
};

export default LogIn;
